


























































































































import Vue, { PropType } from 'vue'
import { number } from '@/utils/validators'
import { debounce } from 'debounce'
import {
  consultPrice,
  getRange,
  getTariffs,
} from '@/api/Remittances/remittances.api'
import { PaymentMethods, VueForm } from '@/utils/interfaces'
import { Client } from '@/api/Agency/agency.interface'
import {
  RemittanceRange,
  RemittancePrice,
  DeliveryCurrenciesEnum,
  Tariff,
} from '@/utils/interfaces/remittance.interface'
import { formatCurrency } from '@/utils/functions'
import ConfirmDialog from '@/components/ConfirmDialog.vue'

export default Vue.extend({
  components: {
    appConfirmDialog: ConfirmDialog,
  },
  props: {
    data: Object as PropType<{ client_origin: string; client_destiny: string }>,
    mlc: Boolean,
    mlx: Boolean,
    ust: Boolean,
    clientDestinyObj: {
      type: Object as PropType<Client>,
    },
  },
  data() {
    return {
      paymentMethods: Object.entries(PaymentMethods).map(([key, value]) => ({
        text: this.$t(key),
        value,
      })),
      rules: {
        required: (v: string) => !!v || this.$t('validation.field-required'),
        number: (v: string) =>
          number(v.toString()) || this.$t('validation.must-be-a-number'),
      },
      crud: {
        delivery_currency: this.mlc
          ? DeliveryCurrenciesEnum.MLC
          : this.mlx
          ? DeliveryCurrenciesEnum.MLX
          : this.ust
          ? DeliveryCurrenciesEnum.UST
          : '',
        amount: '',
        description: '',
        tariff: '',
        distribute_with_network: false,
        payment_method: PaymentMethods.Zelle,
      },
      priceTags: {
        agency_cost: 'agency_cost',
        'shipping-charge': 'cost',
        'total-to-pay': 'price_to_pay',
        'amount-to-deliver': 'delivery_amount',
      },
      prices: null as null | RemittancePrice,
      min: 0,
      max: 1,
      deliveryCurrencies: ['USD', 'CUP', 'EUR', 'UST'], // deliveryCurrencies,
      ranges: [
        { min_amount: 10, max_amount: 100 },
        { min_amount: 1000, max_amount: 2000 },
      ] as RemittanceRange[],
      dialog: false,
      tariffs: [] as Tariff[],
    }
  },
  computed: {
    loading: {
      set(value: boolean): void {
        this.$store.commit('loading', value)
      },
      get(): boolean {
        return this.$store.getters.loading
      },
    },
    client_destiny() {
      return this.$store.getters['remittance/remittance'].client_destiny
    },
    hint(): string {
      return `${this.$t('ranges')}: 
      ${this.ranges
        .map(
          range =>
            `${formatCurrency(range.min_amount)} - ${formatCurrency(
              range.max_amount,
            )}`,
        )
        .join(', ')}
      `
    },
    computedTariffs(): Tariff[] {
      return !this.crud.amount
        ? this.tariffs.filter(
            tariff => tariff.delivery_currency === this.crud.delivery_currency,
          )
        : this.tariffs.filter(
            tariff =>
              Number(tariff.min_amount) <= Number(this.crud.amount) &&
              Number(tariff.max_amount) >= Number(this.crud.amount) &&
              tariff.delivery_currency === this.crud.delivery_currency,
          )
    },
  },
  methods: {
    inRange(v: number | string) {
      for (let index = 0; index < this.ranges.length; index++) {
        const range = this.ranges[index]
        if (Number(v) >= range.min_amount && Number(v) <= range.max_amount) {
          return true
        }
      }
      return this.$t('no-tariff-for-this-price')
    },
    onNext(): any {
      const form = this.$refs.form as VueForm
      if (
        !this.computedTariffs.find(tariff => tariff.uuid === this.crud.tariff)
      )
        this.crud.tariff === ''
      if (!form.validate() || !this.prices) return false
      else {
        this.$store.commit('remittance/remittance', { tariff: this.prices })
        return this.crud
      }
    },
    async onInput(value?: number) {
      if (value) {
        const form = this.$refs.form as VueForm
        await this.$nextTick()
        if (!form.validate()) return
        if (this.inRange(value) === true) {
          this.loading = true
          this.debounce(value, this)
        }
      }
    },
    onDialogInput(payload: boolean) {
      if (!payload) {
        this.$emit('prev-step')
        this.dialog = payload
      }
    },
    debounce: debounce(async function(
      value: number,
      vm: Vue & {
        loading: boolean
        data: any
        crud: any
        prices: any
      },
    ) {
      try {
        const response = await consultPrice({
          client_origin: vm.data.client_origin,
          client_destiny: vm.data.client_destiny,
          amount: vm.crud.amount,
          delivery_currency: vm.crud.delivery_currency,
          tariff: vm.crud.tariff,
          distribute_with_network: vm.crud.distribute_with_network,
        })
        vm.prices = response.data

        if (response.data.was_sent) {
          const confirmed = await vm.$alert({
            title: vm.$t('similar-remittance-was-sent'),
            color: 'success',
            content: vm.$t('remittance-was-sent'),
          })

          if (!confirmed) {
            await vm.$router.push({
              name: 'remittances-list',
            })
          }
        }
      } catch {
        vm.prices = null
      } finally {
        vm.loading = false
      }
    }, 1000),
  },
  watch: {
    client_destiny: {
      async handler(client: Client) {
        if (client.address && client.address.region) {
          this.loading = true
          try {
            getTariffs({
              region: client.address.region,
              type: 'CLIENT',
              limit: 20,
              is_active: true,
            }).then(response => {
              this.tariffs = response.data.results
            })
            const response = await getRange(client.address.region)
            const ranges = response.data.results
            this.ranges = ranges

            if (!ranges.length) {
              this.dialog = true
            } else {
              this.dialog = false
              this.max = 0
            }

            ranges.forEach(range => {
              if (range.max_amount > this.max) {
                this.max = range.max_amount
              }
            })
            ;(this.$refs.form as VueForm).resetValidation()
          } finally {
            this.loading = false
          }
        }
      },
      deep: true,
    },
    'crud.delivery_currency'() {
      if (
        !this.computedTariffs.find(tariff => tariff.uuid === this.crud.tariff)
      )
        this.crud.tariff = ''
    },
    'crud.tariff'(v: string) {
      if (v && this.crud.amount) this.onInput(Number(this.crud.amount))
    },
    'crud.distribute_with_network'() {
      if (this.crud.tariff && this.crud.amount)
        this.onInput(Number(this.crud.amount))
    },
  },
  async mounted() {
    if (!this.clientDestinyObj) return
    if (this.clientDestinyObj.address && this.clientDestinyObj.address.region) {
      this.loading = true
      try {
        getTariffs({
          region: this.clientDestinyObj.address.region,
          type: 'CLIENT',
          limit: 20,
          is_active: true,
        }).then(response => {
          this.tariffs = response.data.results
        })
        const response = await getRange(this.clientDestinyObj.address.region)
        const ranges = response.data.results
        this.ranges = ranges

        if (!ranges.length) {
          this.dialog = true
        } else {
          this.dialog = false
          this.max = 0
        }

        ranges.forEach(range => {
          if (range.max_amount > this.max) {
            this.max = range.max_amount
          }
        })
        ;(this.$refs.form as VueForm).resetValidation()
      } finally {
        this.loading = false
      }
    }
  },
})
